import { render, staticRenderFns } from "./TextfieldBase.vue?vue&type=template&id=45f33898&lang=pug"
import script from "./TextfieldBase.vue?vue&type=script&lang=js"
export * from "./TextfieldBase.vue?vue&type=script&lang=js"
import style0 from "./TextfieldBase.vue?vue&type=style&index=0&id=45f33898&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports